import {
  useGetWorkspaceQuery,
  useGetProjectDetailsQuery,
} from '@sketch/gql-types'
import { BreadcrumbsData } from '../../../projects/types'
import { ApolloError } from 'apollo-client'

export const useGetStashedProjectBreadcrumb = (
  workspaceId: string,
  projectIdentifier: string,
  skip?: boolean
) => {
  const {
    data: workspaceData,
    loading: workspaceLoading,
    error: workspaceError,
  } = useGetWorkspaceQuery({ variables: { identifier: workspaceId } })

  const {
    data: projectData,
    loading: projectLoading,
    error: projectError,
  } = useGetProjectDetailsQuery({
    variables: { projectIdentifier },
    skip,
  })

  const currentProject = projectData?.project

  const parentProject = currentProject?.parentProjects[0] || null
  const parentProjects = [...(currentProject?.parentProjects || [])].reverse()
  const workspace = workspaceData?.workspace

  if (!workspace) {
    return { error: new ApolloError({ errorMessage: 'Workspace not found' }) }
  }

  const breadcrumbs: BreadcrumbsData = {
    siblingProjects: [],
    parentProjects,
    workspace,
    parentProject,
    currentProject: currentProject || null,
  }

  return {
    breadcrumbs,
    loading: workspaceLoading || projectLoading,
    error: workspaceError || projectError,
  }
}
